import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';
const defaultResourcesV2 = {
  en: {
    common: {
      coupons: {
        pageTitle: 'Coupons',
        goToCampaigns: 'Campaigns',
        stats: { total: 'Total Coupons', sent: 'Sent', redeemed: 'Redeemed', pending: 'Pending' },
        exportExcel: 'Export to Excel',
        filters: {
          show: 'Show filters',
          hide: 'Hide filters',
          campaignLabel: 'Filter by Campaign',
          campaignAllOption: 'All Campaigns',
          statusLabel: 'Filter by Status',
          statusOptions: { all: 'All', pending: 'Pending', sent: 'Sent', redeemed: 'Redeemed' },
          dateStart: 'Start Date',
          dateEnd: 'End Date',
          clear: 'Clear Filters',
          showing: 'Showing {{count}} of {{total}} coupons'
        },
        campaignMeta: { idLabel: 'Campaign ID' },
        tableHeaders: {
          index: '#',
          creationDate: 'Creation Date',
          schoolName: 'School Name',
          schoolAddress: 'School Address',
          schoolPhone: 'School Phone',
          userName: 'User Name',
          email: 'Email',
          coupon: 'Coupon',
          activationDate: 'Activation date',
          send: 'Send',
          remove: 'Remove'
        },
        copy: { success: 'Text copied to the clipboard!' },
        actions: { resend: 'Resend', send: 'Send' },
        remove: { confirm: 'Do you really want to remove this demo request?' },
        empty: { filters: 'No coupons found with the applied filters' },
        pagination: {
          itemsPerPage: 'Items per page:',
          range: '{{start}}-{{end}} of {{total}}',
          prev: 'Previous',
          next: 'Next',
          pageOf: 'Page {{page}} of {{pages}}'
        },
        addModal: {
          title: 'Add a Coupon',
          schoolName: 'School name:',
          schoolAddress: 'School address:',
          schoolPhone: 'School phone:',
          userName: 'User name:',
          email: 'Email:',
          provider: 'Provider:',
          close: 'Close',
          save: 'Save coupon',
          providers: { microsoft: 'Microsoft', google: 'Google' }
        },
        sendModal: {
          titleSend: 'Send Coupon',
          titleResend: 'Resend Coupon',
          messageSend: 'Do you really want to send the coupon?',
          messageResend: 'Do you really want to resend the coupon?',
          close: 'Close'
        },
        messages: { exportedSuccess: 'Data exported successfully', noDataExport: 'No data to export' },
        csv: {
          headers: {
            index: '#',
            creationDate: 'Creation Date',
            schoolName: 'School Name',
            schoolAddress: 'School Address',
            schoolPhone: 'School Phone',
            userName: 'User Name',
            email: 'Email',
            coupon: 'Coupon',
            status: 'Status',
            activationDate: 'Activation Date',
            provider: 'Provider'
          },
          status: { redeemed: 'Redeemed', sent: 'Sent', pending: 'Pending' },
          na: 'N/A',
          fileName: { base: 'coupons' }
        }
      },
      campaigns: {
        pageTitle: 'Coupon Campaign Management',
        newCampaign: 'New Campaign',
        empty: {
          title: 'No campaigns created',
          subtitle: 'Start by creating your first coupon campaign',
          createFirst: 'Create First Campaign'
        },
        grid: {
          discount: {
            trial: '🎉 Free Trial',
            percent: '{{value}}% discount',
            fixed: '${{value}} discount'
          },
          discountTag: '(campaign discount)',
          generated: '{{count}} coupons generated',
          assigned: '{{count}} coupons assigned',
          edit: 'Edit',
          viewCoupons: 'View Coupons'
        },
        status: { active: 'Active', scheduled: 'Scheduled', finished: 'Finished', inactive: 'Inactive' },
        modal: { titleCreate: 'Create New Campaign', titleEdit: 'Edit Campaign' },
        form: {
          name: 'Campaign Name *',
          description: 'Description',
          startDate: 'Start Date *',
          endDate: 'End Date *',
          discountType: 'Discount Type *',
          discountTypePercentage: 'Percentage (%)',
          discountTypeFixed: 'Fixed Amount ($)',
          discountValue: 'Discount Value *',
          discountHelp: 'Percentage discount (0-100%) or fixed amount in dollars',
          quantity: 'Coupons to Generate *',
          prefix: 'Coupon Prefix',
          prefixHelp: 'The prefix is only used for the Excel file name when exporting this specific campaign.',
          trialDays: 'Trial Days *',
          trialDaysHelp: 'Number of trial days for coupons (14-60 days)',
          noTrial: 'No trial - discount only',
          noTrialBadge: 'Discount-only campaign (no trial period)',
          noTrialHelp:
            'Coupons apply the discount immediately at checkout. Schools pay from day one, with no free trial. Coupons stay valid until the campaign end date.',
          status: 'Status *',
          statusActive: 'Active',
          statusInactive: 'Inactive'
        },
        note: 'Note: When creating the campaign, coupons will be automatically generated with unique codes.',
        footer: { cancel: 'Cancel', create: 'Create', update: 'Update', campaign: 'Campaign' },
        confirmDelete: { title: 'Confirm Deletion', message: 'Are you sure you want to delete this campaign? This action cannot be undone.' },
        dialog: { cancel: 'Cancel', accept: 'Accept' },
        snackbar: {
          createdSuccess: 'Campaign created successfully',
          updatedSuccess: 'Campaign updated successfully',
          deletedSuccess: 'Campaign deleted successfully',
          loadError: 'Error loading campaigns',
          saveError: 'Error saving the campaign',
          deleteError: 'Error deleting the campaign',
          noTokenError: 'Error: No authentication token. Please, sign in again.',
          percentOverMax: 'Percentage discount cannot be greater than 100%',
          discountNegative: 'Discount cannot be negative'
        },
        confirmTrial: { title: 'Warning: Free Trial', message: '⚠️ You are setting a free trial (100% discount).\n\nUsers will not need to pay. Do you want to continue?' },
        discountMessage: {
          percentageTrial: '<div class="alert alert-success" role="alert"><strong>🎉 Free Trial:</strong> With 100% discount, users will get a completely free trial for the configured number of days (trialDays). <strong>No payment required.</strong></div>',
          percentagePartial: '<div class="alert alert-info" role="alert"><strong>💰 Campaign Discount:</strong> With {{value}}% discount, users must:<ol style="margin-bottom: 0; padding-left: 20px;"><li>Complete the registration form</li><li>Select plan and licenses on the Pricing page</li><li>See normal price vs discounted price comparison</li><li>Pay the discounted price:<ul style="margin-top: 5px; margin-bottom: 0;"><li><strong>Annual payment:</strong> Discount applied to the full annual price</li><li><strong>Monthly payment:</strong> Discount applied only to the first month</li></ul></li></ol></div>',
          fixed: '<div class="alert alert-info" role="alert"><strong>💰 Campaign Discount (Fixed Amount):</strong> With a fixed discount of ${{value}}, users must:<ol style="margin-bottom: 0; padding-left: 20px;"><li>Complete the registration form</li><li>Select plan and licenses on the Pricing page</li><li>See normal price vs discounted price comparison</li><li>Pay the discounted price:<ul style="margin-top: 5px; margin-bottom: 0;"><li><strong>Annual payment:</strong> Discount applied to the full annual price</li><li><strong>Monthly payment:</strong> Discount applied only to the first month</li></ul></li></ol></div>'
        }
      },
      agreements: {
        pageTitle: 'Deposit Agreements',
        pageSubtitle: 'Manage outstanding balances, due date extensions, and payment confirmations.',
        summary: { total: 'Total', pending: 'Pending', paid: 'Paid', overdue: 'Overdue' },
        filters: {
          status: 'Status',
          all: 'All',
          search: 'Search',
          searchPlaceholder: 'School or email'
        },
        table: {
          code: 'Agreement Code',
          school: 'School',
          total: 'Total',
          deposit: 'Deposit',
          balance: 'Balance',
          dueDate: 'Due Date',
          status: 'Status',
          actions: 'Actions',
          depositDateLabel: 'Deposit: {{date}}',
          idLabel: 'ID: {{id}}'
        },
        status: {
          pending: 'Pending',
          paid: 'Paid',
          overdue: 'Overdue',
          cancelled: 'Cancelled'
        },
        actions: {
          newAgreement: 'New Agreement',
          refresh: 'Refresh',
          confirm: 'Confirm',
          extend: 'Extend',
          cancel: 'Cancel',
          createAgreement: 'Create agreement',
          creating: 'Creating...',
          confirming: 'Confirming...',
          confirmBalance: 'Confirm balance',
          saving: 'Saving...',
          saveDate: 'Save date'
        },
        dialogs: {
          create: {
            title: 'Create new agreement',
            description: 'Register negotiated terms and generate a unique agreement code before checkout.'
          },
          confirm: {
            title: 'Confirm received balance',
            description: 'Register the authorization code to mark the agreement as paid and extend the subscription term.',
            authorizationCode: 'Authorization code'
          },
          extend: {
            title: 'Extend due date',
            description: 'Select a new due date to update both the agreement and the school temporary expiration date.',
            newDate: 'New date'
          }
        },
        messages: {
          loadError: 'Unable to load deposit agreements.',
          createRequired: 'School, email, licenses, and total amount are required.',
          createSuccess: 'Agreement created successfully.',
          createError: 'Unable to create the agreement.',
          authorizationRequired: 'Authorization code is required to confirm the balance.',
          confirmSuccess: 'Balance confirmed successfully.',
          confirmError: 'Unable to confirm the agreement balance.',
          extendRequired: 'Select a new due date.',
          extendSuccess: 'Due date updated successfully.',
          extendError: 'Unable to extend the due date.'
        },
        empty: 'No agreements to display.',
        loading: 'Loading agreements...',
        notRedeemedHint: 'Code not redeemed yet - available once the deposit is paid',
        form: {
          schoolName: 'School Name',
          schoolRFC: 'RFC',
          contactEmail: 'Contact Email',
          licenseCount: 'Number of Licenses',
          billingCycle: 'Billing Cycle',
          billingCycleMonthly: 'Monthly',
          billingCycleAnnual: 'Annual',
          planName: 'Plan',
          planPlaceholder: 'Select a plan',
          planLoading: 'Loading plans...',
          totalAmount: 'Total Amount (MXN)',
          defaultPrice: 'Default price:',
          useDefaultPrice: 'Use default',
          defaultPriceUnavailable:
            'Default price unavailable. Enter the negotiated amount manually.',
          depositPercentage: 'Negotiated Deposit Percentage (%)',
          previewDeposit: 'Deposit amount:',
          previewBalance: 'Balance amount:'
        },
        common: { na: 'N/A' }
      },
      toolbar: {
        appLauncher: 'App Launcher',
        notifications: 'Notifications',
        settings: 'Settings',
        language: 'Language',
        homeDashboard: 'HOME Dashboard',
        fullscreenEnter: 'Enter fullscreen',
        fullscreenExit: 'Exit fullscreen',
      },
      search: { placeholder: 'Search apps...', modulesPlaceholder: 'Search modules...' },
      appLauncher: {
        title: 'App Launcher',
        pinned: 'Pinned Apps',
        recent: 'Recent',
        noResults: 'No apps matched your search.',
        all: 'All',
      },
      favorites: { title: 'Favorite Apps' },
      menu: { settings: 'Settings', themeColors: 'Theme Colors', logout: 'Sign out' },
      notifications: { title: 'Notifications' },
      settingsPanel: {
        title: 'Navigation Settings',
        tabs: { general: 'General', categories: 'Categories', colors: 'Colors', layout: 'Layout Styles' },
        save: 'Save Changes',
        displayPreferences: 'Display Preferences',
        categories: { addButton: 'Add', existingCategories: 'Existing Categories' },
        general: {
          topBarIconStyleTitle: 'Top Bar Icon Style',
          topBarIconStyleDescColored: 'Show colored backgrounds behind icons',
          topBarIconStyleDescMinimal: 'Show minimalist black-line icons',
          showAppNameLabelsTitle: 'Show App Name Labels',
          showAppNameLabelsDesc: 'Show app names next to icons in the top navigation bar',
          showHoverTooltipsTitle: 'Show Hover Tooltips',
          showHoverTooltipsDesc: 'Show app names when hovering over icons',
          showStarShortcutTitle: 'Show Star Shortcut',
          showStarShortcutDesc: 'Show yellow star icon to quickly pin and manage apps',
          showAppLauncherTitle: 'Show App Launcher',
          showAppLauncherDesc: 'Show app launcher icon in the top navigation bar',
          showSearchBoxTitle: 'Show Search Box',
          showSearchBoxDesc: 'Show modules search box in the top navigation bar',
          showCommandPaletteTitle: 'Show Command Palette',
          showCommandPaletteDesc: 'Show command palette button in the top navigation bar',
          showHomeDashboardTitle: 'Show HOME Dashboard',
          showHomeDashboardDesc: 'Show HOME icon to access pinned and frequent apps dashboard',
          dashboardModeTitle: 'Dashboard Mode',
          dashboardModePinned: 'Show pinned apps in dashboard',
          dashboardModeFrequent: 'Show most frequently used apps',
          fontSizeControlTitle: 'Show Font Size Control',
          fontSizeControlDesc: 'Show font size accessibility control (70% - 130%)',
          languageSelectorTitle: 'Show Language Selector',
          languageSelectorDesc: 'Show language selector with flag icons for multilingual support',
          fullscreenToggleTitle: 'Show Fullscreen Toggle',
          fullscreenToggleDesc: 'Show fullscreen toggle button for immersive experience',
          moduleGroupsTitle: 'Module Groups (Chrome style)',
          moduleGroupsDesc:
            'Enable Chrome-style tab grouping to organize modules into colored, collapsible groups (max 4 groups, 4 modules each)',
          groupNamesTitle: 'Show Group Names',
          groupNamesDesc: 'Show group names when groups are expanded (e.g., "Group 1:", "Marketing:")',
          resetOptions: 'Reset Options',
          resetCategoriesButton: 'Reset Categories to Default Values',
          resetColorsButton: 'Reset Colors to Default Values',
        },
        colors: {
          categoryColorsTitle: 'Category Colors',
          appColorOverridesTitle: 'App Color Overrides',
          appColorOverridesDesc: 'Override individual app colors. Leave empty to use category color.',
          reset: 'Reset',
        },
        layout: {
          preferencesTitle: 'Navigation Layout Preferences',
          preferencesDesc:
            'Choose how your navigation is displayed. Each layout is optimized for different use cases and screen sizes.',
          recommended: 'Recommended',
          bestPractice: 'Best Practice:',
        },
      },
      'SETTINGS_PANEL.TABS.GENERAL': 'General',
      'SETTINGS_PANEL.TABS.CATEGORIES': 'Categories',
      'SETTINGS_PANEL.TABS.COLORS': 'Colors',
      'SETTINGS_PANEL.TABS.LAYOUT': 'Layout Styles',
      'SETTINGSPANEL_SAVE': 'Save Changes',
    },
  },
  es: {
    common: {
      coupons: {
        pageTitle: 'Cupones',
        goToCampaigns: 'Campañas',
        stats: { total: 'Total Cupones', sent: 'Enviados', redeemed: 'Redimidos', pending: 'Pendientes' },
        exportExcel: 'Exportar a Excel',
        filters: {
          show: 'Mostrar filtros',
          hide: 'Ocultar filtros',
          campaignLabel: 'Filtrar por Campaña',
          campaignAllOption: 'Todas las Campañas',
          statusLabel: 'Filtrar por Estado',
          statusOptions: { all: 'Todos', pending: 'Pendientes', sent: 'Enviados', redeemed: 'Redimidos' },
          dateStart: 'Fecha Inicio',
          dateEnd: 'Fecha Fin',
          clear: 'Limpiar Filtros',
          showing: 'Mostrando {{count}} de {{total}} cupones'
        },
        campaignMeta: { idLabel: 'ID de Campaña' },
        tableHeaders: {
          index: '#',
          creationDate: 'Fecha de Creación',
          schoolName: 'Nombre de Escuela',
          schoolAddress: 'Dirección de Escuela',
          schoolPhone: 'Teléfono de Escuela',
          userName: 'Nombre de Usuario',
          email: 'Email',
          coupon: 'Cupón',
          activationDate: 'Fecha de Activación',
          send: 'Enviar',
          remove: 'Eliminar'
        },
        copy: { success: 'Texto copiado al portapapeles' },
        actions: { resend: 'Reenviar', send: 'Enviar' },
        remove: { confirm: '¿Realmente desea eliminar esta solicitud de demo?' },
        empty: { filters: 'No se encontraron cupones con los filtros aplicados' },
        pagination: {
          itemsPerPage: 'Items por página:',
          range: '{{start}}-{{end}} de {{total}}',
          prev: 'Anterior',
          next: 'Siguiente',
          pageOf: 'Página {{page}} de {{pages}}'
        },
        addModal: {
          title: 'Agregar un Cupón',
          schoolName: 'Nombre de escuela:',
          schoolAddress: 'Dirección de escuela:',
          schoolPhone: 'Teléfono de escuela:',
          userName: 'Nombre de usuario:',
          email: 'Email:',
          provider: 'Proveedor:',
          close: 'Cerrar',
          save: 'Guardar cupón',
          providers: { microsoft: 'Microsoft', google: 'Google' }
        },
        sendModal: {
          titleSend: 'Enviar Cupón',
          titleResend: 'Reenviar Cupón',
          messageSend: '¿Desea realmente enviar el cupón?',
          messageResend: '¿Desea realmente reenviar el cupón?',
          close: 'Cerrar'
        },
        messages: { exportedSuccess: 'Datos exportados exitosamente', noDataExport: 'No hay datos para exportar' },
        csv: {
          headers: {
            index: '#',
            creationDate: 'Fecha de Creación',
            schoolName: 'Nombre de Escuela',
            schoolAddress: 'Dirección de Escuela',
            schoolPhone: 'Teléfono de Escuela',
            userName: 'Nombre de Usuario',
            email: 'Email',
            coupon: 'Cupón',
            status: 'Estado',
            activationDate: 'Fecha de Activación',
            provider: 'Proveedor'
          },
          status: { redeemed: 'Redimido', sent: 'Enviado', pending: 'Pendiente' },
          na: 'N/A',
          fileName: { base: 'cupones' }
        }
      },
      campaigns: {
        pageTitle: 'Gestión de Campañas de Cupones',
        newCampaign: 'Nueva Campaña',
        empty: {
          title: 'No hay campañas creadas',
          subtitle: 'Comienza creando tu primera campaña de cupones',
          createFirst: 'Crear Primera Campaña'
        },
        grid: {
          discount: {
            trial: '🎉 Trial Gratis',
            percent: '{{value}}% descuento',
            fixed: '${{value}} descuento'
          },
          discountTag: '(descuento de campaña)',
          generated: '{{count}} cupones generados',
          assigned: '{{count}} cupones asignados',
          edit: 'Editar',
          viewCoupons: 'Ver Cupones'
        },
        status: { active: 'Activa', scheduled: 'Programada', finished: 'Finalizada', inactive: 'Inactiva' },
        modal: { titleCreate: 'Crear Nueva Campaña', titleEdit: 'Editar Campaña' },
        form: {
          name: 'Nombre de Campaña *',
          description: 'Descripción',
          startDate: 'Fecha de Inicio *',
          endDate: 'Fecha de Fin *',
          discountType: 'Tipo de Descuento *',
          discountTypePercentage: 'Porcentaje (%)',
          discountTypeFixed: 'Monto Fijo ($)',
          discountValue: 'Valor del Descuento *',
          discountHelp: 'Porcentaje de descuento (0-100%) o monto fijo en dólares',
          quantity: 'Cantidad de Cupones a Generar *',
          prefix: 'Prefijo de Cupones',
          prefixHelp: 'El prefijo se usará solo para el nombre del archivo Excel cuando se exporte esta campaña específica.',
          trialDays: 'Días de Trial *',
          trialDaysHelp: 'Número de días de trial para los cupones (14-60 días)',
          noTrial: 'Sin prueba - solo descuento',
          noTrialBadge: 'Campaña de solo descuento (sin período de prueba)',
          noTrialHelp:
            'Los cupones aplican el descuento directamente en el checkout. Las escuelas pagan desde el primer día, sin prueba gratuita. Los cupones siguen válidos hasta la fecha de fin de la campaña.',
          status: 'Estado *',
          statusActive: 'Activa',
          statusInactive: 'Inactiva'
        },
        note: 'Nota: Al crear la campaña, se generarán automáticamente los cupones con códigos únicos.',
        footer: { cancel: 'Cancelar', create: 'Crear', update: 'Actualizar', campaign: 'Campaña' },
        confirmDelete: { title: 'Confirmar Eliminación', message: '¿Está seguro que desea eliminar esta campaña? Esta acción no se puede deshacer.' },
        dialog: { cancel: 'Cancelar', accept: 'Aceptar' },
        snackbar: {
          createdSuccess: 'Campaña creada exitosamente',
          updatedSuccess: 'Campaña actualizada exitosamente',
          deletedSuccess: 'Campaña eliminada exitosamente',
          loadError: 'Error al cargar campañas',
          saveError: 'Error al guardar la campaña',
          deleteError: 'Error al eliminar la campaña',
          noTokenError: 'Error: No hay token de autenticación. Por favor, inicie sesión nuevamente.',
          percentOverMax: 'El descuento porcentual no puede ser mayor al 100%',
          discountNegative: 'El descuento no puede ser negativo'
        },
        confirmTrial: { title: 'Advertencia: Trial Gratuito', message: '⚠️ Está configurando un trial gratuito (100% de descuento).\n\nLos usuarios no necesitarán pagar. ¿Desea continuar?' },
        discountMessage: {
          percentageTrial: '<div class="alert alert-success" role="alert"><strong>🎉 Trial Gratis:</strong> Con 100% de descuento, los usuarios obtendrán un trial completamente gratuito por el número de días configurado (trialDays). <strong>No se requerirá pago.</strong></div>',
          percentagePartial: '<div class="alert alert-info" role="alert"><strong>💰 Descuento de Campaña:</strong> Con {{value}}% de descuento, los usuarios deberán:<ol style="margin-bottom: 0; padding-left: 20px;"><li>Completar formulario de registro</li><li>Seleccionar plan y número de licencias en la página de Precios</li><li>Ver comparación de precio normal vs precio con descuento</li><li>Pagar el precio descontado:<ul style="margin-top: 5px; margin-bottom: 0;"><li><strong>Pago anual:</strong> Descuento aplicado al precio anual completo</li><li><strong>Pago mensual:</strong> Descuento aplicado solo a la primera mensualidad</li></ul></li></ol></div>',
          fixed: '<div class="alert alert-info" role="alert"><strong>💰 Descuento de Campaña (Monto Fijo):</strong> Con un descuento fijo de ${{value}}, los usuarios deberán:<ol style="margin-bottom: 0; padding-left: 20px;"><li>Completar formulario de registro</li><li>Seleccionar plan y número de licencias en la página de Precios</li><li>Ver comparación de precio normal vs precio con descuento</li><li>Pagar el precio descontado:<ul style="margin-top: 5px; margin-bottom: 0;"><li><strong>Pago anual:</strong> Descuento aplicado al precio anual completo</li><li><strong>Pago mensual:</strong> Descuento aplicado solo a la primera mensualidad</li></ul></li></ol></div>'
        }
      },
      agreements: {
        pageTitle: 'Acuerdos de Depósito',
        pageSubtitle: 'Administra saldos pendientes, extensiones y confirmaciones de pago.',
        summary: { total: 'Total', pending: 'Pendientes', paid: 'Pagados', overdue: 'Vencidos' },
        filters: {
          status: 'Estado',
          all: 'Todos',
          search: 'Buscar',
          searchPlaceholder: 'Escuela o correo'
        },
        table: {
          code: 'Código de acuerdo',
          school: 'Escuela',
          total: 'Total',
          deposit: 'Depósito',
          balance: 'Saldo',
          dueDate: 'Vencimiento',
          status: 'Estado',
          actions: 'Acciones',
          depositDateLabel: 'Depósito: {{date}}',
          idLabel: 'ID: {{id}}'
        },
        status: {
          pending: 'Pendiente',
          paid: 'Pagado',
          overdue: 'Vencido',
          cancelled: 'Cancelado'
        },
        actions: {
          newAgreement: 'Nuevo acuerdo',
          refresh: 'Actualizar',
          confirm: 'Confirmar',
          extend: 'Extender',
          cancel: 'Cancelar',
          createAgreement: 'Crear acuerdo',
          creating: 'Creando...',
          confirming: 'Confirmando...',
          confirmBalance: 'Confirmar saldo',
          saving: 'Guardando...',
          saveDate: 'Guardar fecha'
        },
        dialogs: {
          create: {
            title: 'Crear nuevo acuerdo',
            description: 'Registra los términos negociados y genera un código único de acuerdo antes del checkout.'
          },
          confirm: {
            title: 'Confirmar saldo recibido',
            description: 'Registra el código de autorización para marcar el acuerdo como pagado y extender la vigencia de la suscripción.',
            authorizationCode: 'Código de autorización'
          },
          extend: {
            title: 'Extender fecha de vencimiento',
            description: 'Selecciona una nueva fecha de vencimiento para actualizar el acuerdo y la fecha de expiración temporal de la escuela.',
            newDate: 'Nueva fecha'
          }
        },
        messages: {
          loadError: 'No se pudieron cargar los acuerdos de depósito.',
          createRequired: 'Escuela, correo, licencias y monto total son obligatorios.',
          createSuccess: 'Acuerdo creado correctamente.',
          createError: 'No se pudo crear el acuerdo.',
          authorizationRequired: 'El código de autorización es obligatorio para confirmar el saldo.',
          confirmSuccess: 'Saldo confirmado correctamente.',
          confirmError: 'No se pudo confirmar el saldo del acuerdo.',
          extendRequired: 'Selecciona una nueva fecha de vencimiento.',
          extendSuccess: 'Fecha de vencimiento actualizada.',
          extendError: 'No se pudo extender la fecha de vencimiento.'
        },
        empty: 'No hay acuerdos para mostrar.',
        loading: 'Cargando acuerdos...',
        notRedeemedHint: 'Código aún no canjeado - disponible cuando se pague el depósito',
        form: {
          schoolName: 'Nombre de escuela',
          schoolRFC: 'RFC',
          contactEmail: 'Correo de contacto',
          licenseCount: 'Número de licencias',
          billingCycle: 'Ciclo de facturación',
          billingCycleMonthly: 'Mensual',
          billingCycleAnnual: 'Anual',
          planName: 'Plan',
          planPlaceholder: 'Selecciona un plan',
          planLoading: 'Cargando planes...',
          totalAmount: 'Monto total (MXN)',
          defaultPrice: 'Precio por defecto:',
          useDefaultPrice: 'Usar por defecto',
          defaultPriceUnavailable:
            'Precio por defecto no disponible. Ingresa el monto negociado manualmente.',
          depositPercentage: 'Porcentaje de depósito negociado (%)',
          previewDeposit: 'Monto de depósito:',
          previewBalance: 'Saldo pendiente:'
        },
        common: { na: 'N/A' }
      },
      toolbar: {
        appLauncher: 'Lanzador de Apps',
        notifications: 'Notificaciones',
        settings: 'Configuración',
        language: 'Idioma',
        homeDashboard: 'HOME Dashboard',
        fullscreenEnter: 'Pantalla completa',
        fullscreenExit: 'Salir de pantalla completa',
      },
      search: { placeholder: 'Buscar apps...', modulesPlaceholder: 'Buscar módulos...' },
      appLauncher: {
        title: 'App Launcher',
        pinned: 'Apps Fijadas',
        recent: 'Recientes',
        noResults: 'No se encontraron apps que coincidan con tu búsqueda.',
        all: 'Todas',
      },
      favorites: { title: 'Apps Favoritas' },
      menu: { settings: 'Configuración', themeColors: 'Colores de Tema', logout: 'Cerrar Sesión' },
      notifications: { title: 'Notificaciones' },
      settingsPanel: {
        title: 'Configuración de Navegación',
        tabs: { general: 'General', categories: 'Categorías', colors: 'Colores', layout: 'Estilos de Layout' },
        save: 'Guardar Cambios',
        displayPreferences: 'Preferencias de Visualización',
        categories: { addButton: 'Agregar', existingCategories: 'Categorías Existentes' },
        general: {
          topBarIconStyleTitle: 'Estilo de Iconos en Barra Superior',
          topBarIconStyleDescColored: 'Mostrar fondos de color detrás de los iconos',
          topBarIconStyleDescMinimal: 'Mostrar iconos minimalistas en línea negra',
          showAppNameLabelsTitle: 'Mostrar Etiquetas de Nombre de App',
          showAppNameLabelsDesc:
            'Mostrar nombres de apps junto a los iconos en la barra de navegación superior',
          showHoverTooltipsTitle: 'Mostrar Tooltips al Pasar el Mouse',
          showHoverTooltipsDesc: 'Mostrar nombres de apps al pasar el mouse sobre los iconos',
          showStarShortcutTitle: 'Mostrar Atajo de Estrella',
          showStarShortcutDesc: 'Mostrar icono de estrella amarilla para fijar y gestionar apps rápidamente',
          showAppLauncherTitle: 'Mostrar App Launcher',
          showAppLauncherDesc: 'Mostrar icono de lanzador de apps en la barra de navegación superior',
          showSearchBoxTitle: 'Mostrar Caja de Búsqueda',
          showSearchBoxDesc: 'Mostrar caja de búsqueda de módulos en la barra de navegación superior',
          showCommandPaletteTitle: 'Mostrar Command Palette',
          showCommandPaletteDesc: 'Mostrar botón de command palette en la barra de navegación superior',
          showHomeDashboardTitle: 'Mostrar Dashboard HOME',
          showHomeDashboardDesc:
            'Mostrar icono HOME para acceder al dashboard con apps fijadas y frecuentes',
          dashboardModeTitle: 'Modo de Dashboard',
          dashboardModePinned: 'Mostrar apps fijadas en dashboard',
          dashboardModeFrequent: 'Mostrar apps más frecuentemente usadas',
          fontSizeControlTitle: 'Mostrar Control de Tamaño de Fuente',
          fontSizeControlDesc:
            'Mostrar control de ajuste de tamaño de fuente para accesibilidad (70% - 130%)',
          languageSelectorTitle: 'Mostrar Selector de Idioma',
          languageSelectorDesc:
            'Mostrar selector de idioma con iconos de banderas para soporte multilingüe',
          fullscreenToggleTitle: 'Mostrar Toggle de Pantalla Completa',
          fullscreenToggleDesc: 'Mostrar botón de toggle de pantalla completa para experiencia inmersiva',
          moduleGroupsTitle: 'Module Groups (Estilo Chrome)',
          moduleGroupsDesc:
            'Habilitar agrupación de pestañas estilo Chrome para organizar módulos en grupos coloreados y colapsables (máx. 4 grupos, 4 módulos cada uno)',
          groupNamesTitle: 'Mostrar Nombres de Grupo',
          groupNamesDesc:
            'Mostrar nombres de grupos cuando los grupos están expandidos (ej: "Grupo 1:", "Marketing:")',
          resetOptions: 'Opciones de Reinicio',
          resetCategoriesButton: 'Reiniciar Categorías a Valores por Defecto',
          resetColorsButton: 'Reiniciar Colores a Valores por Defecto',
        },
        colors: {
          categoryColorsTitle: 'Colores de Categorías',
          appColorOverridesTitle: 'Sobrescrituras de Color de Apps',
          appColorOverridesDesc:
            'Sobrescribir colores individuales de apps. Dejar vacío para usar color de categoría.',
          reset: 'Reiniciar',
        },
        layout: {
          preferencesTitle: 'Preferencias de Layout de Navegación',
          preferencesDesc:
            'Elige cómo se muestra tu navegación. Cada layout está optimizado para diferentes casos de uso y tamaños de pantalla.',
          recommended: 'Recomendado',
          bestPractice: 'Mejor Práctica:',
        },
      },
      'SETTINGS_PANEL.TABS.GENERAL': 'General',
      'SETTINGS_PANEL.TABS.CATEGORIES': 'Categorías',
      'SETTINGS_PANEL.TABS.COLORS': 'Colores',
      'SETTINGS_PANEL.TABS.LAYOUT': 'Estilos de Layout',
      'SETTINGSPANEL_SAVE': 'Guardar Cambios',
    },
  },
};
const defaultResources={en:{common:{toolbar:{appLauncher:'App Launcher',notifications:'Notifications',settings:'Settings',language:'Language',homeDashboard:'HOME Dashboard',fullscreenEnter:'Enter fullscreen',fullscreenExit:'Exit fullscreen'},search:{placeholder:'Search apps...',modulesPlaceholder:'Search modules...'},appLauncher:{title:'App Launcher',pinned:'Pinned Apps',recent:'Recent',noResults:'No apps matched your search.',all:'All'},favorites:{title:'Favorite Apps'},menu:{settings:'Settings',themeColors:'Theme Colors',logout:'Sign out'},notifications:{title:'Notifications'},settingsPanel:{title:'Navigation Settings',tabs:{general:'General',categories:'Categories',colors:'Colors',layout:'Layout Styles'},save:'Save Changes',displayPreferences:'Display Preferences'},'SETTINGS_PANEL.TABS.GENERAL':'General','SETTINGS_PANEL.TABS.CATEGORIES':'Categories','SETTINGS_PANEL.TABS.COLORS':'Colors','SETTINGS_PANEL.TABS.LAYOUT':'Layout Styles','SETTINGSPANEL_SAVE':'Save Changes'}},es:{common:{toolbar:{appLauncher:'Lanzador de Apps',notifications:'Notificaciones',settings:'Configuración',language:'Idioma',homeDashboard:'HOME Dashboard',fullscreenEnter:'Pantalla completa',fullscreenExit:'Salir de pantalla completa'},search:{placeholder:'Buscar apps...',modulesPlaceholder:'Buscar módulos...'},appLauncher:{title:'App Launcher',pinned:'Apps Fijadas',recent:'Recientes',noResults:'No se encontraron apps que coincidan con tu búsqueda.',all:'Todas'},favorites:{title:'Apps Favoritas'},menu:{settings:'Configuración',themeColors:'Colores de Tema',logout:'Cerrar Sesión'},notifications:{title:'Notificaciones'},settingsPanel:{title:'Configuración de Navegación',tabs:{general:'General',categories:'Categorías',colors:'Colores',layout:'Estilos de Layout'},save:'Guardar Cambios',displayPreferences:'Preferencias de Visualización'},'SETTINGS_PANEL.TABS.GENERAL':'General','SETTINGS_PANEL.TABS.CATEGORIES':'Categorías','SETTINGS_PANEL.TABS.COLORS':'Colores','SETTINGS_PANEL.TABS.LAYOUT':'Estilos de Layout','SETTINGSPANEL_SAVE':'Guardar Cambios'}}};

 

 

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: defaultResourcesV2,
    fallbackLng: 'en',
    supportedLngs: ['en', 'es'],
    load: 'languageOnly',
    nonExplicitSupportedLngs: true,
    lowerCaseLng: true,
    ns: ['common'],
    defaultNS: 'common',
    debug: false,
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    detection: {
      order: ['localStorage', 'querystring', 'navigator'],
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
